import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';

import { AuthService } from '../../services/AuthService';
import { UserService } from '../../services/UserService';
import useRequest from '../../hooks/useRequest';
import { isMobile } from '../../helpers/Mobile';

import InputCheckbox from '../../components/atoms/InputCheckbox';

import LoginHeader from '../../components/atoms/LoginHeader';
import FooterMobile from '../../components/atoms/FooterMobile';
import GradientButton from '../../components/atoms/GradientButton';

import './styles.scss';

const ConfirmUnsubscribeView = (props) => {
    const history = useHistory();
    const { token } = useParams();

    useEffect(() => {
        console.log(token);
        UserService.confirmUnsubscribe(token)
            .then(data => {
                showSuccess('Usuario dado de baja');
                console.log('confirmar baja');
            }).catch((error) => {
                dealWithError(error, 'Error al confirmar baja de usuario');
            });
    }, []);

    const {
        submitted, success, message,
        beforeSubmit, afterSubmit, showSuccess, showError,
        dealWithError
    } = useRequest();

    const handleSubmit = (e) => {
        e.preventDefault();
        beforeSubmit();

        history.push('/login');
    }

    return (
        <div className="confirm-unsubscribe-container">
            <LoginHeader></LoginHeader>

            <div className="confirm-unsubscribe-content">
                <form className="confirm-unsubscribe-form" onSubmit={handleSubmit}>
                    {(success === false && message) &&
                        <h1 className="confirm-unsubscribe-title">{message}</h1>
                    }
                    {(success === true && message) && 
                        <h1 className="confirm-unsubscribe-title">Tu cuenta ha sido dada de baja</h1>
                    }      
                    {(success === true && message) && 
                        <h2 className="confirm-unsubscribe-subtitle">Gracias por haber utilizado la Oficina Virtual</h2>
                    }
                </form>
            </div>
            {isMobile && <FooterMobile></FooterMobile>}
        </div>
    );
}

export default withTranslation()(ConfirmUnsubscribeView);